import { render, staticRenderFns } from "./BackendTable.vue?vue&type=template&id=8ee59b7c"
import script from "./BackendTable.vue?vue&type=script&lang=js"
export * from "./BackendTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports